import {
  IconExperience,
  IconRecommended,
  IconRocket,
  Strong,
  Text,
} from 'braid-design-system';

export const JOB_AD_FEATURE_CHART_SITE_CONFIG: JobAdFeatureChartSiteConfig = {
  headerPlan: [
    {
      label: 'Basic',
      icon: <IconRecommended tone="brandAccent" />,
      textSpan: (
        <Text size="xsmall">
          Offers a balance between performance and cost with exposure to
          relevant candidates - ideal for <Strong>easy-to-fill roles</Strong>
        </Text>
      ),
      text: 'Offers a balance between performance and cost with exposure to relevant candidates - ideal for easy-to-fill roles',
    },
    {
      label: 'Advanced',
      icon: <IconRocket tone="brandAccent" />,
      textSpan: (
        <Text size="xsmall">
          Offers a balance between performance and cost with exposure to
          relevant candidates - ideal for <Strong>easy-to-fill roles</Strong>
        </Text>
      ),
      text: 'Offers a balance between performance and cost with exposure to relevant candidates - ideal for easy-to-fill roles',
    },
    {
      label: 'Premium',
      icon: <IconExperience tone="brandAccent" />,
      textSpan: (
        <Text size="xsmall">
          Our top-performing ad, with maximum exposure and features to help you
          stand out - designed for{' '}
          <Strong>hard-to-fill, critical and urgent roles</Strong>
        </Text>
      ),
      text: 'Our top-performing ad, with maximum exposure and features to help you stand out - designed for hard-to-fill, critical and urgent roles.',
    },
  ],
  jobAdPlanInfo: [
    {
      title: 'Exposure in search and recommendations',
      type: 'badge',
      data: ['Standard', 'Promoted', 'Prioritised'],
    },
    {
      title: 'Candidate invitations',
      type: 'badge',
      data: [20, 30, 80],
    },
    {
      title: 'Enhanced targetting',
      type: 'icon',
      data: ['no', 'yes', 'yes'],
    },
    {
      title: 'Promoted on competitive ads',
      type: 'icon',
      data: ['no', 'yes', 'yes'],
    },
    {
      title: 'Maintain exclusivity on your ad',
      type: 'icon',
      data: ['no', 'no', 'yes'],
    },
    {
      title: 'Your ad sent exclusively to high-fit candidates',
      type: 'icon',
      data: ['no', 'no', 'yes'],
    },
    {
      title: 'Branding',
      type: 'icon',
      data: ['optional', 'optional', 'yes'],
    },
  ],
  colNum: 4,
};

export interface JobAdFeatureChartSiteConfig {
  headerPlan: Array<{
    label: string;
    icon: React.ReactNode;
    textSpan: React.ReactNode;
    text: string;
  }>;
  jobAdPlanInfo: Array<{
    title: string;
    type: 'badge' | 'icon';
    data: string[] | number[];
  }>;
  colNum: 4 | 5;
}
